// @flow
/** @jsx h */

import { h } from 'preact'

import styles from './VoteCounter.css'
import { formatNumber } from '../../../../../helpers/formatNumber'
import { themeToClassName } from '../../../../../helpers/themeToClassName'
import { bem } from '../../../../../helpers/bem'
type Props = {
  voteCount: number
}

/* eslint-disable jsx-a11y/aria-role */
export function VoteCounter (props: Props, context: { theme: string }) {
  const { voteCount } = props

  return (
    <div className={bem(styles.voteCounter, themeToClassName(context.theme))} role='text'>
      <div className={styles.voteCounter__count}>
        <span className='nrk-sr'>Antall stemmer: {voteCount}</span>
        <span>{formatNumber(voteCount)} stemmer</span>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/VoteCounter/VoteCounter.js